<template>
  <div class="payment_card">
    <v-row>
      <v-col>
        <v-text-field label="Номер карты" :rules="rules.card" v-model="card"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col><v-text-field label="Месяц" :rules="rules.mouth" v-model="mouth"/></v-col>
      <v-col><v-text-field label="Год" :rules="rules.year" v-model="year"/></v-col>
    </v-row>
    <v-row>
      <v-col><v-text-field label="CVV" :rules="rules.cvv" v-model="cvv"/></v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: "payment_card",
  components: {},
  data: () => ({
    rules: {
      card: [
        (value) => !!value || "Обязательное.",
        (value) =>
          (value && value.length >= 4 * 4) || `Минимально ${4 * 4} цифры`,
      ],
      mouth: [
        (value) => !!value || "Обязательное.",
        (value) =>
          (value && value >= 1 && value <=12) || `Минимально 1 максимально 12`,
      ],
      year: [
        (value) => !!value || "Обязательное.",
        (value) =>
          (value && value.length == 4) || `Всего 4 цифры`,
      ],
      cvv: [
        (value) => !!value || "Обязательное.",
        (value) =>
          (value && value.length == 3) || `Всего 3 цифры`,
      ],
    },
  }),
  computed: {
      card: {
          get(){return this.$store.getters.PaymentCard.card},
          set(value){this.$store.commit('setPaymentCardParam',{name: 'card',value})}
      },
      mouth: {
          get(){return this.$store.getters.PaymentCard.mouth},
          set(value){this.$store.commit('setPaymentCardParam',{name: 'mouth',value})}
      },
      year: {
          get(){return this.$store.getters.PaymentCard.year},
          set(value){this.$store.commit('setPaymentCardParam',{name: 'year',value})}
      },
      cvv: {
          get(){return this.$store.getters.PaymentCard.cvv},
          set(value){this.$store.commit('setPaymentCardParam',{name: 'cvv',value})}
      }
  },
};
</script>
<style lang="sass" scoped>
</style>